import React from 'react';

// @mui
import { TableCell } from '@mui/material';
import { fDateTime } from '../../utils/formatTime';
import GridTruncatedText from '../../sections/@dashboard/grid/GridTruncatedText';

export default class GridDateTimeCell extends React.Component {
    render() {
        const baseStyle = this.props.styles;
        const { value, field } = this.props;
        return (
            <TableCell key={field.id} align="left" sx={{ ...baseStyle, whiteSpace: 'nowrap' }}>
                <GridTruncatedText>
                    {value ? fDateTime(value, 'd MMM yyyy HH:mm') : '—'}
                </GridTruncatedText>
            </TableCell>
        );
    }
}
